var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uLine: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-line/u-line" */ "uview-ui/components/u-line/u-line.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([
    _vm.$u.addStyle(_vm.customStyle),
    {
      flexDirection:
        (_vm.labelPosition || _vm.parentData.labelPosition) === "left"
          ? "row"
          : "column",
    },
  ])
  var g0 =
    _vm.required || _vm.leftIcon || _vm.label
      ? _vm.$u.addUnit(_vm.labelWidth || _vm.parentData.labelWidth)
      : null
  var s1 =
    _vm.required || _vm.leftIcon || _vm.label
      ? _vm.__get_style([
          _vm.parentData.labelStyle,
          {
            justifyContent:
              _vm.parentData.labelAlign === "left"
                ? "flex-start"
                : _vm.parentData.labelAlign === "center"
                ? "center"
                : "flex-end",
          },
        ])
      : null
  _vm.$initSSP()
  var g1 =
    !!_vm.message && _vm.parentData.errorType === "message"
      ? _vm.$u.addUnit(
          _vm.parentData.labelPosition === "top"
            ? 0
            : _vm.labelWidth || _vm.parentData.labelWidth
        )
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        g0: g0,
        s1: s1,
        g1: g1,
      },
    }
  )
  if (_vm.$scope.data.scopedSlotsCompiler === "augmented") {
    _vm.$setSSP("error", {
      message: _vm.message,
    })
  }
  _vm.$callSSP()
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }